import { formatNumber } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import * as yup from 'yup'
import { updateUser, fetchEmailExist } from '../actions/AuthAction'
import { Button, TextField, ErrorText, Form, Label, Stack, Validator } from '../components'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { ERROR_INVALID_EMAIL, REQUIRED_FIELD } from './../utils/validation/constants'
import AuthContent from './AuthContent'

class RegisterEmailView extends React.Component {
  static propTypes = {
    mobileNumber: PropTypes.string,
    error: PropTypes.any,
    phaseInformationError: PropTypes.any,
    applicationProfileError: PropTypes.any,
    updateUser: PropTypes.func,
    fetchEmailExist: PropTypes.func,
    phoneIsVerifiable: PropTypes.bool,
  }

  validation = [
    {
      id: 'email',
      validation: yup
        .string()
        .email(ERROR_INVALID_EMAIL)
        .required(REQUIRED_FIELD),
    },
  ]

  state = {
    email: '',
    inputValidation: {},
    isSubmitting: false,
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  resetErrors = () => {
    this.setState({
      inputValidation: {},
    })
  }

  handleEmail = async event => {
    event.preventDefault()
    this.setState({ isSubmitting: true }, () => {
      Validator(this.validation, this.state)
        .then(() => {
          this.setState({
            error: null,
            inputValidation: null,
            isSubmitting: false,
          })
          if (this.props.phoneIsVerifiable) {
            this.props.updateUser({ email: this.state.email })
            routeService.goToRegisterPasswordPage()
          } else {
            this.props.fetchEmailExist(this.state.email)
          }
        })
        .catch((validationErrors = {}) => {
          this.setState({
            error: this.props.error,
            inputValidation: validationErrors,
            isSubmitting: false,
          })
        })
    })
  }

  componentDidMount() {
    if (!this.props.mobileNumber) {
      routeService.goToLoginPage()
    }
  }

  render() {
    const { error, phaseInformationError, applicationProfileError, mobileNumber } = this.props
    const { inputValidation = {} } = this.state

    return (
      <Fragment>
        <AuthContent title={translationService.registerCompleteProfileTitle()} hasToken={false}>
          <Form onSubmit={this.handleEmail}>
            {(phaseInformationError || applicationProfileError) && (
              <ErrorText>{translationService.generalError()}</ErrorText>
            )}

            {mobileNumber && (
              <div>
                <Label>{translationService.enteredMobileNumberPlaceholder()}</Label>

                <Stack distribution="EqualSpacing">
                  <Stack.Item>
                    <strong>{formatNumber(mobileNumber, 'International')}</strong>
                  </Stack.Item>
                  <Stack.Item>
                    <Link to={routeService.getPrefixPath() + '/login'}>{translationService.system('edit')}</Link>
                  </Stack.Item>
                </Stack>
              </div>
            )}

            <TextField
              type="email"
              label={translationService.registerEmailLabel()}
              id="email"
              value={this.state.email}
              onChange={this.onValueChange}
              error={(inputValidation && inputValidation.email) || (error && error.email)}
            />

            <div>
              <Button submit primary onClick={this.handleEmail}>
                {translationService.system('next')}
              </Button>
            </div>
          </Form>
        </AuthContent>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {}, error, phoneIsVerifiable } = AuthReducer
  const { phaseInformationError, applicationProfileError } = FlowReducer
  const { mobileNumber } = user
  return {
    mobileNumber,
    error,
    phaseInformationError,
    applicationProfileError,
    phoneIsVerifiable,
  }
}

const mapDispatchToProps = dispatch => ({
  updateUser: userInfo => dispatch(updateUser(userInfo)),
  fetchEmailExist: email => dispatch(fetchEmailExist(email)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(RegisterEmailView)



// WEBPACK FOOTER //
// ./src/views/RegisterEmailView.js